import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import KVKKModal from '../Auth/KVKKModal';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [isKvkkOpen, setIsKvkkOpen] = useState(false);

  return (
    <div className="landing-page-container">
      {/* Top Header */}
      <header className="landing-header">
        <div className="landing-header-content">
          <div className="landing-logo">
            <span className="logo-badge-icon">🛡️</span>
            <div className="logo-titles">
              <span className="logo-brand">UZMAN DESTEK</span>
              <span className="logo-subtext">İş Güvenliği Uzmanı Portalı</span>
            </div>
          </div>
          <div className="landing-auth-buttons">
            <button className="landing-forgot-btn" onClick={() => navigate('/forgot-password')}>
              Şifremi Unuttum
            </button>
            <button className="landing-login-btn" onClick={() => navigate('/login')}>
              Giriş Yap
            </button>
            <button className="landing-register-btn" onClick={() => navigate('/register')}>
              14 Gün Ücretsiz Başla 🚀
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <span className="hero-badge">⚡ Bağımsız & Hızlı İSG Yönetimi</span>
          <h1 className="hero-title">
            İş Güvenliği Uzmanları İçin <br />
            <span className="text-gradient">Akıllı, Sade ve Güçlü</span> Çalışma Masası
          </h1>
          <p className="hero-description">
            Artık karmaşık sistemlerle veya hantal programlarla vakit kaybetmeyin.
            İşyerlerinizi manuel kaydedin, tüm saha ziyaretlerinizi, risk analizlerinizi ve yıllık planlarınızı
            tek bir platformdan, hem web hem mobil PWA üzerinden kolayca yönetin.
          </p>

          <div className="hero-actions">
            <button className="cta-primary-btn" onClick={() => navigate('/register')}>
              Hemen Ücretsiz Kayıt Ol
              <span className="cta-arrow">→</span>
            </button>
            <button className="cta-secondary-btn" onClick={() => navigate('/login')}>
              Mevcut Hesaba Giriş
            </button>
            <button className="cta-forgot-btn" onClick={() => navigate('/forgot-password')}>
              Şifremi Unuttum
            </button>
          </div>

          <div className="hero-highlights">
            <div className="highlight-item">
              <span className="hl-icon">✅</span>
              <span>14 Gün Tam Kapsamlı Ücretsiz Deneme</span>
            </div>
            <div className="highlight-item">
              <span className="hl-icon">🔒</span>
              <span>Uçtan Uca Çift Taraflı Veri Şifreleme</span>
            </div>
            <div className="highlight-item">
              <span className="hl-icon">📱</span>
              <span>Mobil Cihazlar İçin Tam PWA Desteği</span>
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features-section">
        <div className="section-header">
          <h2>İSG Uzmanının İhtiyacı Olan Her Şey</h2>
          <p>Saha profesyonellerinin doğrudan geri bildirimleriyle tasarlandı.</p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon-wrapper" style={{ background: '#e0f2fe', color: '#0284c7' }}>
              🏢
            </div>
            <h3>Hızlı Manuel İşyeri Yönetimi</h3>
            <p>
              İşyerlerinizi saniyeler içinde unvan, tehlike sınıfı ve çalışan sayısıyla manuel ekleyin, süreçlerini baştan sona kontrol edin.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon-wrapper" style={{ background: '#fef3c7', color: '#d97706' }}>
              🏃
            </div>
            <h3>Saha Ziyaret & Not Takibi</h3>
            <p>
              Tüm işyeri ziyaretlerinizi planlayın, geçmiş ziyaretleri ve kalan ziyaret haklarınızı gecikmeden takip edin.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon-wrapper" style={{ background: '#fce7f3', color: '#db2777' }}>
              📑
            </div>
            <h3>İSG Belge & Şablon Motoru</h3>
            <p>
              Risk değerlendirmesi, acil durum eylem planı ve yıllık eğitim planlarını hazır şablonlarla dakikalar içinde hazırlayın.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon-wrapper" style={{ background: '#dcfce7', color: '#16a34a' }}>
              🔐
            </div>
            <h3>AES-256 Yüksek Güvenlik</h3>
            <p>
              Hassas işyeri verileri, vergi numaraları ve telefon bilgileri güçlü çift taraflı şifreleme ile veri tabanında korunur.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing / Trial Teaser */}
      <section className="pricing-teaser-section">
        <div className="pricing-teaser-card">
          <div className="teaser-left">
            <h3>Uygun Fiyatlar, Şeffaf Abonelik</h3>
            <p>14 günlük ücretsiz deneme sonrası aylık 150 TL'den başlayan avantajlı planlar.</p>
          </div>
          <div className="teaser-right">
            <div className="teaser-prices">
              <span>Aylık: <strong>150 TL</strong></span>
              <span>6 Aylık: <strong>750 TL</strong></span>
              <span>Yıllık: <strong>1.500 TL</strong></span>
            </div>
            <button className="teaser-btn" onClick={() => navigate('/register')}>
              Hemen Başla ⚡
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <p>© 2026 Uzman Destek. Tüm hakları saklıdır. İş Sağlığı ve Güvenliği Uzmanları İçin Geliştirilmiştir.</p>
        <p style={{ marginTop: '8px', fontSize: '0.85rem' }}>
          <button 
            type="button" 
            onClick={() => setIsKvkkOpen(true)}
            style={{ background: 'none', border: 'none', color: '#94a3b8', textDecoration: 'underline', cursor: 'pointer' }}
          >
            KVKK ve Aydınlatma Metni
          </button>
        </p>
      </footer>

      <KVKKModal isOpen={isKvkkOpen} onClose={() => setIsKvkkOpen(false)} />
    </div>
  );
};

export default LandingPage;
